import React from "react";

import { normaliseUrl, seoHost, urlFormat } from "./seo-helper";

export const buildMetaHrefLangAlternateLinks = (
  locales: string[],
  alternateUrls: NodeJS.Dict<string>,
  dynamicUrl: string | undefined,
): (JSX.Element | null)[] => {
  const alternateLinks = locales?.map((locale) => {
    const lowerLocale = locale.toLowerCase();
    const hasLocale = alternateUrls[lowerLocale];
    if (hasLocale) {
      return (
        <link
          key={lowerLocale}
          rel="alternate"
          hrefLang={lowerLocale}
          href={transformMetaHrefLangAlternateUrl(
            lowerLocale,
            alternateUrls[locale] as string,
            dynamicUrl,
          )}
          data-testid={lowerLocale}
        />
      );
    } else return null;
  });

  return alternateLinks;
};

const transformMetaHrefLangAlternateUrl = (
  locale: string,
  url: string,
  dynamicUrl: string | undefined,
): string => {
  if (url.indexOf(",-w-,") >= 0 && dynamicUrl) {
    dynamicUrl = normaliseUrl(dynamicUrl);
    if (dynamicUrl.startsWith("/")) {
      dynamicUrl = dynamicUrl.substring(1);
    }
    const newLocale = dynamicUrl.indexOf(`/${locale}`) >= 0 ? "" : `/${locale}`;
    return `${seoHost}${newLocale}/${urlFormat(dynamicUrl, false)}`;
  }

  url = normaliseUrl(url);

  const urlSegments = url
    .split("/")
    .filter(Boolean)
    .map((segment) => urlFormat(segment, false));

  const newLocale = url.indexOf(`${locale}`) >= 0 ? "" : `/${locale}`;

  return `${seoHost}${newLocale}/${urlSegments.join("/")}`;
};

export const buildMetaHrefLangDefaultLink = (
  language: string | undefined,
  link: string | undefined,
): JSX.Element | null => {
  if (language && language === "en" && link) {
    if (link.startsWith("/")) {
      link = link.substring(1);
    }
    link = normaliseUrl(link);
    return (
      <link
        rel="alternate"
        hrefLang="x-default"
        data-testid="x-default"
        href={`${seoHost}/en/${urlFormat(link, false)}`}
      />
    );
  } else {
    return null;
  }
};

export const buildMetaHrefLangCurrentLink = (
  language: string | undefined,
  link: string | undefined,
): JSX.Element | null => {
  if (language && link) {
    link = normaliseUrl(link);
    return (
      <link
        rel="alternate"
        hrefLang={language.toLowerCase()}
        data-testid={language.toLowerCase()}
        href={`${seoHost}/${language}${urlFormat(link, false)}`}
      />
    );
  } else {
    return null;
  }
};
